(function () {
  'use strict';
  if (window.BoiLoadSommelier) return;
  var runtimePromise;
  var loading = false;

  function mount() { return document.getElementById('somml-container'); }

  function busy(container, value, failed) {
    var root = container.querySelector('#somml-root');
    var ui = JSON.parse(root.querySelector('[data-sommelier-ui]').textContent);
    root.querySelectorAll('.boi-sommelier-static-control').forEach(function (control) {
      control.disabled = value;
      if (value) control.setAttribute('aria-busy', 'true');
      else control.removeAttribute('aria-busy');
    });
    root.querySelector('[data-sommelier-load-status]').textContent = value ? ui.loading : (failed ? ui.load_error : '');
  }

  function dispatch(action) {
    if (action && action.intent) return window.BoiSommelierSendIntent(action.intent, action.label || '');
    return window.BoiSommelierOpen();
  }

  function loadSommelier(action) {
    var container = mount();
    if (!container || loading) return Promise.resolve();
    if (runtimePromise) return runtimePromise.then(function () { return dispatch(action); });
    loading = true;
    busy(container, true);
    runtimePromise = new Promise(function (resolve, reject) {
      var script = document.createElement('script');
      script.src = container.getAttribute('data-runtime-url');
      script.async = true;
      script.dataset.boiSommelierRuntime = 'true';
      script.onload = function () {
        if (typeof window.BoiSommelierOpen !== 'function') { reject(new Error('Sommelier mount unavailable')); return; }
        resolve();
      };
      script.onerror = function () { script.remove(); reject(new Error('Sommelier runtime unavailable')); };
      document.head.appendChild(script);
    });
    return runtimePromise.then(function () {
      loading = false;
      busy(container, false);
      return dispatch(action);
    }, function (error) {
      loading = false;
      runtimePromise = null;
      busy(container, false, true);
      throw error;
    });
  }

  window.BoiLoadSommelier = loadSommelier;
  var initialMount = mount();
  if (initialMount) {
    try {
      var initialRoot = initialMount.querySelector('#somml-root');
      var used = JSON.parse(sessionStorage.getItem('somml:bubblesUsed:' + initialRoot.dataset.sommelierLanguage + ':' + initialMount.dataset.productId) || '{}');
      var primary = initialRoot.querySelector('[data-sommelier-primary]');
      var extra = initialRoot.querySelector('[data-sommelier-extra]');
      var available = Array.from(initialRoot.querySelectorAll('[data-sommelier-intent]')).filter(function (button) {
        button.hidden = !!used[button.dataset.sommelierIntent];
        return !button.hidden;
      });
      available.forEach(function (button, index) { (index < 4 || !extra ? primary : extra).appendChild(button); });
      var more = initialRoot.querySelector('[data-sommelier-more]');
      if (more) more.hidden = available.length <= 4;
      var suggestions = initialRoot.querySelector('[data-sommelier-suggestions]');
      suggestions.hidden = available.length === 0 && !initialRoot.querySelector('[data-sommelier-mobile-open]');
      suggestions.classList.toggle('is-empty', available.length === 0);
    } catch (_) {}
  }
  document.addEventListener('click', function (event) {
    if (!(event.target instanceof Element)) return;
    var question = event.target.closest('#somml-root [data-sommelier-intent]');
    if (question) {
      loadSommelier({intent:question.dataset.sommelierIntent,label:question.querySelector('span').textContent.trim()}).catch(function () {});
    } else if (event.target.closest('#somml-launcher-placeholder, [data-sommelier-mobile-open]')) {
      loadSommelier().catch(function () {});
    }
  });
})();
